module.exports = __webpack_public_path__ + "img/occupancy-detector-sm.d9f7097a.svg";